import React from 'react';
import ConfirmPopup from '../../../common/confirm-popup';

const ResubmitConfirmDialog = props => (
  <ConfirmPopup
    confirmLabel="Resubmit"
    header="Are you sure you want to resubmit this submission?"
    onClose={result => props.onClose(result)}
  >
    <div className="ta-left">
      <p>
        This will send the submission to Valassis again.
      </p>
    </div>
  </ConfirmPopup>
);

export default ResubmitConfirmDialog;



// WEBPACK FOOTER //
// ./src/components/admin/submissions/list/resubmit-confirm-dialog.jsx